import React, { useState } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { getCtaStorage } from '../../utils/cta-storage'
import { CloseButton } from '@local/do-secundo-closebutton'
import { Anchor } from '../Anchor/Anchor'
import { useOOGlobals } from '@local/do-secundo-oo-globals-provider'
import styles from './TakeoutCTA.module.css'

const CTA_KEY = 'takeout-cta'
const LINK = 'https://toasttakeout.page.link/oov3'
const DATA_TESTIDS = ['add-to-cart-button', 'cart-checkout-button']

const querySelectorListener = (listener) => (e) => {
  if (e && e.target && typeof listener === 'function') {
    if (DATA_TESTIDS.indexOf(e.target.getAttribute('data-testid')) > -1) {
      listener(e)
    }
  }
}

const attachToTargetClick = (listener) => {
  document.addEventListener('click', querySelectorListener(listener))
}

const detachFromTargetClick = (listener) => {
  document.removeEventListener('click', querySelectorListener(listener))
}

export const TakeoutCTA = React.memo(() => {
  const { toastTakeoutCTAEnabled } = useOOGlobals()
  const [hasSeen, setHasSeen] = useState(Boolean(getCtaStorage().get(CTA_KEY)))

  const dismiss = React.useCallback((e) => {
    try {
      detachFromTargetClick(dismiss)
      getCtaStorage().set(CTA_KEY, true)
      setHasSeen(true)
    } catch (err) {
      // Being cautious because we're attaching to a global listener
    }
  }, [])

  React.useEffect(() => {
    detachFromTargetClick(dismiss)
    if (toastTakeoutCTAEnabled && !hasSeen) {
      if (!hasSeen) {
        attachToTargetClick(dismiss)
      }
    }
    return () => {
      detachFromTargetClick(dismiss)
    }
  }, [hasSeen, dismiss, toastTakeoutCTAEnabled])

  if (!toastTakeoutCTAEnabled) {
    detachFromTargetClick(dismiss)
    return null
  }

  return (
    <div data-testid='takeout-cta'>
      <TransitionGroup component={null}>
        {hasSeen === false && (
          <CSSTransition classNames={{ ...styles }} timeout={250}>
            <div
              className={styles.takeoutCta}
              data-testid='takeout-cta-content'
            >
              <div className={styles.closeButton}>
                <CloseButton
                  onClick={dismiss}
                  data-testid='close-button-takeout-cta'
                  to=''
                />
              </div>
              <p className={styles.header}>
                Order now on the Toast Takeout app!
              </p>
              <Anchor
                data-testid='cta-link'
                rel='noopener'
                href={LINK}
                target='_blank'
                onClick={dismiss}
              >
                <div className={styles.content} />
              </Anchor>
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  )
})
